// @ts-nocheck FIXME
/**
 * WebSocket Communication Utils
 */
import Bowser from "bowser";
import Utils from "../../../../main/utils/index.js";

function isFunction(func) {
	const getType = {};
	return func && getType.toString.call(func) === "[object Function]";
}

const WsComm = function () {
	// TODO: fix this
	// eslint-disable-next-line @typescript-eslint/no-this-alias
	const self = this;

	// WebSocket
	self.ws = null;

	self.safeClose = false;

	// List of handlers subscribers for incoming messages
	self.handlers = {};

	self.reconnectHandler = undefined;
	self.isReconnecting = false;

	self.authenticate = function () {
		if (!self.ws)
			return; // WS closed sometime before this function was called

		const authMsg = {
			type:  "auth",
			token: self.user.accessToken
		};

		// Additional data
		const b = Bowser.parse(self.user.userAgent);
		authMsg.platform = `${b.browser.name} ${b.browser.version} (${b.os.name} ${b.os.version})`;
		authMsg.version = self.user.version;

		self.ws.send(JSON.stringify(authMsg));
	};

	const opening = new Utils.Async.ControlledPromise();

	self.reconnect = function () {
		console.log("PN Data WsSync: reconnecting");
		self.isReconnecting = true;
		const {baseUri, accountUuid, accessToken, userAgent, version} = self.user;
		return self.connect(baseUri, accountUuid, accessToken, userAgent, version);
	};

	self.connect = async function (baseUri, accountUuid, accessToken, userAgent, version) {
		self.user = {baseUri, accountUuid, accessToken, userAgent, version};

		// We may be in the process of disconnecting, so let's wait for that (`handleClose` sets `self.ws` to null).
		await Utils.Async.waitUntil(() => !self.ws);

		const uri = self.user.baseUri + self.user.accountUuid;

		self.ws = new WebSocket(uri);
		self.ws.onclose = self.handleClose;
		self.ws.onerror = self.handleError;
		self.ws.onmessage = self.handleMessage;
		self.ws.onopen = self.handleOpen;

		self.safeClose = false;

		return opening.start();
	};

	const retry = Utils.Async.exponentialBackoff(self.reconnect, {maxTimeout: 5 * 60 * 1000});

	self.disconnect = function () {
		if (self.ws)
			self.ws.close();
		self.safeClose = true;
	};

	self.handleClose = function (evt) {
		if (opening.isPending()) {
			const error = new Error(`PN Data WsSync: closed with reason: ${evt.reason} (${evt.code}).`);
			opening.reject(error);
		}

		const willRetry = !self.safeClose;
		if (willRetry)
			retry();

		self.ws = null;
		console.log("PN Data WsSync: close " + (willRetry ? "(will retry)" : "(will not retry)"));
	};

	self.handleError = function (evt) {
		console.log("PN Data WsSync: error", evt.data);
	};

	self.handleMessage = function (evt) {
		if (!("data" in evt))
			return;

		let msg;
		try {
			msg = JSON.parse(evt.data);
			console.log("PN Data WsSync: msg", `[${msg.type}]`, msg);
		} catch (e) {
			console.error("PN Data WsSync: could not parse message", evt.data);
			return;
		}

		switch (msg.type) {
			case "auth-response":
				if (self.handlers["auth-response"])
					self.handlers["auth-response"](msg);

				switch (msg.status) {
					case "success":
						retry.cancel();

						if (self.isReconnecting && self.reconnectHandler)
							self.reconnectHandler();

						break;

					case "fail":
						if (self.authFailHandler)
							self.authFailHandler();

					// eslint-disable-next-line no-fallthrough
					default: // "fail" or "timeout"
						self.ws = null;
						console.error("PN Data WsSync: Unable to authenticate with websocket!");
						break;
				}
				break;

			default:
				self.handleMessageResponse(msg.type, msg.data);
				break;
		}
	};

	self.handleMessageResponse = function (handlerId, data) {
		if (!self.handlers[handlerId])
			return;

		self.handlers[handlerId](data);
	};

	self.handleOpen = function () {
		self.authenticate();
		self.isReconnecting = false;
		opening.resolve();
	};

	self.setHandler = function (handler, fn) {
		if (!isFunction(fn))
			return;

		self.handlers[handler] = fn;
	};

	self.setReconnectHandler = function (fn) {
		if (!isFunction(fn))
			return;

		self.reconnectHandler = fn;
	};

	self.setAuthFailHandler = function (fn) {
		if (!isFunction(fn))
			return;

		self.authFailHandler = fn;
	};

	return {
		connect:             self.connect,
		disconnect:          self.disconnect,
		setHandler:          self.setHandler,
		setReconnectHandler: self.setReconnectHandler,
		setAuthFailHandler:  self.setAuthFailHandler
	};
};

export default WsComm;
